import React from "react";
import "./GivingBack.css";
import { HeartHandshake, Globe2, Church, HandHeart } from "lucide-react";
import hands from '../images/hand holding.jpg'
const GivingBack = () => {
  return (
    <section className="giving-section">
      <div className="giving-container">
        <div className="giving-header">
          <HeartHandshake size={50} color="#b76e79" />
          <h1>Giving Back</h1>
          <p>
            We lead by example, guided by the needs of the city we inhabit, the
            communities we build, and the world we live in. We’ve taken
            Environmental and Social responsibility to heart.
          </p>
        </div>

        <div className="giving-content">
          <div className="giving-text">
            <h2>Our Heart for Service</h2>
            <p>
              EAEC is a Christian business and one of its major pillars of
              servant leadership is <strong>giving back to the community.</strong>{" "}
              Proverbs 3:27 says, “Do not withhold good from those to whom it is due
              when it is in your power to act.” In line with this, EAEC donates its
              time, funds, and organizational resources through{" "}
              <strong>Exemplar</strong>.
            </p>

            <p>
              <strong>Exemplar</strong> is the EAEC’s Corporate Social Responsibility
              (CSR) arm — a Bible-based, nonprofit initiative solely devoted to
              improving the quality of living and spiritual enrichment of our
              community through charitable giving, volunteering, and in-house
              initiatives.
            </p>

            <p>
              There is room for everyone’s time, treasure, and talent in this field.
              As ransomed sons and daughters of God, serving the vulnerable is both
              the least we can do and the most we can do.
            </p>
          </div>

          <div className="giving-image">
            <img
              src={hands}
              alt="Community service"
            />
          </div>
        </div>

        <div className="exemplar-section">
          <h2>Exemplar: Our CSR Arm</h2>
          <p>
            Exemplar operates through a three-prong approach to giving back:
            <strong> relief</strong>, <strong>rehabilitation</strong>, and{" "}
            <strong>development</strong> — making lasting impacts across several
            sectors.
          </p>

          <div className="exemplar-grid">
            <div className="exemplar-card">
              <Globe2 className="exemplar-icon" />
              <h3>Education</h3>
              <p>Supporting learning programs and scholarships for children and youth.</p>
            </div>

            <div className="exemplar-card">
              <Church className="exemplar-icon" />
              <h3>Spiritual Enrichment</h3>
              <p>Encouraging faith-based development and values-driven service.</p>
            </div>

            <div className="exemplar-card">
              <HandHeart className="exemplar-icon" />
              <h3>Community Development</h3>
              <p>Improving quality of life through legal aid, sanitation, and healthcare.</p>
            </div>
          </div>
        </div>

        <div className="giving-footer">
          <p>
            Through Exemplar, we believe in being the hands and feet of Christ to
            those around us — serving with love, humility, and excellence.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GivingBack;
